document.addEventListener("click", async function (e) {
    const button = e.target.closest(".add-to-cart-button");
    if (!button) return;

    e.preventDefault();

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.disabled = true;
    button.classList.add("loading");

    try {
        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.description || "Unable to add product.");
        }

        // Wait a little so Shopify updates the cart
        setTimeout(() => {

            document.dispatchEvent(
                new CustomEvent("dispatch:cart-drawer:refresh")
            );

            document.dispatchEvent(
                new CustomEvent("dispatch:cart-drawer:open", {
                    detail: {
                        opener: button
                    }
                })
            );

        }, 150);

    } catch (err) {
        console.error(err);
        alert(err.message);
    } finally {
        button.disabled = false;
        button.classList.remove("loading");
    }
});